import {useMemo} from 'react'
import {
  ControlledFilterTable,
  ControlledFilterTableBaseColumn,
} from '../../../../components/table/ControlledFilterTable/ControlledFilterTable'
import {ControlledFilterTableBody} from '../../../../components/table/ControlledFilterTable/ControlledFilterTableBody'
import {ControlledFilterTableContainer} from '../../../../components/table/ControlledFilterTable/ControlledFilterTableContainer'
import {ControlledFilterTableHeaders} from '../../../../components/table/ControlledFilterTable/ControlledFilterTableHeaders'
import {ControlledFilterTablePagination} from '../../../../components/table/ControlledFilterTable/ControlledFilterTablePagination'
import {SubmissionLogModel} from '../../../../models/SubmissionLogModel'
import {SearchResultModel} from '../../../../models/SearchResultModel'
import {FilterModel} from '../../../../models/FilterModel'
import {Typography} from '@mui/material'
import moment from 'moment'
import {generatedCode} from '../../../../utils/codeExtractor'
import {SubmissionHistoryTableFilters} from './SubmissionHistoryTableFilters'


export interface SubmissionHistoryTableProps {
  searchResults?: SearchResultModel<SubmissionLogModel>
  filters: FilterModel
  onFilter: (filter: FilterModel) => void
  onRefresh?: () => void
  id?: string
}

export const SubmissionHistoryTable = ({
  onRefresh,
  id,
  ...tableProps
}: SubmissionHistoryTableProps) => {
  const columns = useMemo((): ControlledFilterTableBaseColumn<SubmissionLogModel>[] => {
    const columns: ControlledFilterTableBaseColumn<SubmissionLogModel>[] = [
      {
        field: 'createdAt',
        label: 'Date',
        sortable: true,
        render: ({data}) => (
          <Typography component='span'>{moment(data.createdAt).format('lll')}</Typography>
        ),
      },
      {
        field: 'description',
        label: 'Description',
        sortable: true,
        render: ({data}) => <>{data.description}</>,
      },
      {
        field: 'moduleName',
        label: 'Module',
        sortable: true,
        render: ({data}) => <>{data.moduleName}</>,
      },
      {
        field: 'type',
        label: 'Type',
        sortable: true,
        render: ({data}) => <>{data.type}</>,
      },
    ]
    return columns
  }, [])

  return (
    <>
      <ControlledFilterTableContainer
        idExtractor={generatedCode}
        columns={columns}
        id={id}
        {...tableProps}
      >
        <SubmissionHistoryTableFilters />

        <ControlledFilterTable>
          <ControlledFilterTableHeaders />
          <ControlledFilterTableBody />
        </ControlledFilterTable>
        <ControlledFilterTablePagination />
      </ControlledFilterTableContainer>
    </>
  )
}
